// Wraps a lazy import so a success is reused but a failure is forgotten: after
// a network blip on the chunk, the next call imports again instead of
// returning the same rejected promise until the page is reloaded.
export function createRetryingLoader<T>(importer: () => Promise<T>): () => Promise<T> {
  let pending: Promise<T> | null = null;

  return () => {
    if (pending === null) {
      const attempt = importer();
      pending = attempt;
      attempt.catch(() => {
        if (pending === attempt) {
          pending = null;
        }
      });
    }
    return pending;
  };
}
